/*
業界の選択上限
*/
if($('.js-upper-imit5').length) {
  $(function () {
    checked();
    $('.js-upper-imit5 input').on('click',function() {
      checked();
    });
    function checked() {
      var checked_length = $('.js-upper-imit5 input:checked').length;
        // 選択上限は5つまで
        if (checked_length >= 5) {
          $('.js-upper-imit5 input:not(:checked)').prop('disabled', true);
        } else {
          $('.js-upper-imit5 input:not(:checked)').prop('disabled', false);
        }
    };
  });
};
